import { CALL_API } from "admin/middlewares/api";

import moment from "moment";

export const ADD_CAMPAIGN_REQUEST = "ADD_CAMPAIGN_REQUEST";
export const ADD_CAMPAIGN_SUCCESS = "ADD_CAMPAIGN_SUCCESS";
export const ADD_CAMPAIGN_ERROR = "ADD_CAMPAIGN_ERROR";

export const add_campaign = (addCampaignDto) => {
  const {
    name,
    bonusInSek,
    bonusInEur,
    targetInSek,
    targetInEur,
    lengthInDays,
    startDate,
    endDate,
  } = addCampaignDto;

  return {
    [CALL_API]: {
      endpoint: "/api/admin/refer-a-friend/add-campaign",
      method: "POST",
      data: {
        Name: name,
        BonusInSek: bonusInSek,
        BonusInEur: bonusInEur,
        TargetInSek: targetInSek,
        TargetInEur: targetInEur,
        DaysToReachTarget: lengthInDays,
        Start: moment(startDate).utc().toDate().toISOString(),
        End: moment(endDate).utc().toDate().toISOString(),
      },
      authenticatedRequest: true,
      types: [
        ADD_CAMPAIGN_REQUEST,
        { method: campaign_added_success },
        ADD_CAMPAIGN_ERROR,
      ],
    },
  };
};

const campaign_added_success = (response) => {
  return (dispatch) => {
    dispatch({
      type: ADD_CAMPAIGN_SUCCESS,
      response,
    });

    dispatch(get_campaigns());
  };
};

export const GET_CAMPAIGNS_REQUEST = "GET_CAMPAIGNS_REQUEST";
export const GET_CAMPAIGNS_SUCCESS = "GET_CAMPAIGNS_SUCCESS";
export const GET_CAMPAIGNS_ERROR = "GET_CAMPAIGNS_ERROR";

export const get_campaigns = () => {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/refer-a-friend/get-campaigns",
      method: "GET",
      authenticatedRequest: true,
      types: [
        GET_CAMPAIGNS_REQUEST,
        GET_CAMPAIGNS_SUCCESS,
        GET_CAMPAIGNS_ERROR,
      ],
    },
  };
};

export const GET_REFERRED_REQUEST = "GET_REFERRED_REQUEST";
export const GET_REFERRED_SUCCESS = "GET_REFERRED_SUCCESS";
export const GET_REFERRED_ERROR = "GET_REFERRED_ERROR";

export const get_referred = () => {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/refer-a-friend/get-rewards",
      method: "GET",
      authenticatedRequest: true,
      types: [GET_REFERRED_REQUEST, GET_REFERRED_SUCCESS, GET_REFERRED_ERROR],
    },
  };
};

export const DELETE_CAMPAIGN_REQUEST = "DELETE_CAMPAIGN_REQUEST";
export const DELETE_CAMPAIGN_SUCCESS = "DELETE_CAMPAIGN_SUCCESS";
export const DELETE_CAMPAIGN_ERROR = "DELETE_CAMPAIGN_ERROR";

export const delete_campaign = (id) => {
  return {
    [CALL_API]: {
      endpoint: "/refer-a-friend/deactivate-campaign",
      method: "POST",
      data: {
        Id: id,
      },
      authenticatedRequest: true,
      types: [
        DELETE_CAMPAIGN_REQUEST,
        { method: campaign_deleted_success },
        DELETE_CAMPAIGN_ERROR,
      ],
    },
  };
};

const campaign_deleted_success = (response) => {
  return (dispatch) => {
    dispatch({
      type: DELETE_CAMPAIGN_SUCCESS,
      response,
    });

    dispatch(get_campaigns());
  };
};

export const register_all_bonus_orders = (list) => {
  return (dispatch) => {
    const elem = list.pop();
    // eslint-disable-next-line no-undef
    dispatch(register_bonus_orders(elem.Id, list));
  };
};

export const UPDATE_START_DATE_REQUEST = "UPDATE_START_DATE_REQUEST";
export const UPDATE_START_DATE_SUCCESS = "UPDATE_START_DATE_SUCCESS";
export const UPDATE_START_DATE_ERROR = "UPDATE_START_DATE_ERROR";

export const update_start_date = (stringTime, id) => {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/refer-a-friend/set-campaign-start-time",
      method: "POST",
      authenticatedRequest: true,
      data: {
        Time: moment(stringTime).utc().toDate().toISOString(),
        Id: id,
      },
      types: [
        UPDATE_START_DATE_REQUEST,
        { method: updateDateOnSuccess.bind(this, UPDATE_START_DATE_SUCCESS) },
        UPDATE_START_DATE_ERROR,
      ],
    },
  };
};

export const UPDATE_END_DATE_REQUEST = "UPDATE_END_DATE_REQUEST";
export const UPDATE_END_DATE_SUCCESS = "UPDATE_END_DATE_SUCCESS";
export const UPDATE_END_DATE_ERROR = "UPDATE_END_DATE_ERROR";

export const update_end_date = (stringTime, id) => {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/refer-a-friend/set-campaign-end-time",
      method: "POST",
      authenticatedRequest: true,
      data: {
        Time: moment(stringTime).utc().toDate().toISOString(),
        Id: id,
      },
      types: [
        UPDATE_END_DATE_REQUEST,
        { method: updateDateOnSuccess.bind(this, UPDATE_END_DATE_SUCCESS) },
        UPDATE_END_DATE_ERROR,
      ],
    },
  };
};

export const updateDateOnSuccess = (type, response) => {
  return (dispatch) => {
    dispatch({
      type,
      response,
    });
    dispatch(get_campaigns());
  };
};
